<template>

  <article class="">
    <cabeceraEN></cabeceraEN>
    <section class="cabecera">
      <img src="./cabecera.jpg" alt="" >
      <h2>About Us</h2>
    </section>
    <section class="cont-1300">
      <div class="left">
        <h2>
          Our History
        </h2>
        <p>
          This challenging undertaking dates to 1997, when the companies <strong>YPF S.A.,
Petrobras, and Dow Argentina</strong> conceived a project to fully exploit the potential of
natural gas.<br><br>

          With the development of this project, the valuable components of natural gas became the building blocks of the petrochemical industry, boosting its growth and making a major contribution to Argentina’s economy.
        </p>
      </div>
      <a  class="right">
       <img src="./1.png" alt="">
       
      </a>
    </section>
   <section class="cont-1300 left">
      <div class="right">
       <img src="./1.jpg" alt="">
      </div>
   
      <div class="left">
        <h2>
         Our Company
        </h2>
        <p>
         We are a leading Argentine company in the gas and petrochemical industries. Ever since 2001, we have been a key player in natural gas processing in the Neuquén Basin.<br>

         We add value to natural gas through the separation and fractionation of natural gas into its individual components to recover ethane—the main raw-material? Feedstock used in the petrochemical industry—, <strong>propane, butane and natural gasoline.</strong><br>

         We supply the domestic market with our products as well as several international markets in strict compliance with the highest world-class quality standards. Our shareholding structure is made up of YPF (38%), Petrobras (34%) , and Dow (28%).
        </p>
      </div>
     </section>
     <section class="instalaciones">
         <h1>Our Facilities</h1>
       <div class="cont-1299">
        <div class="mod">
          <div class="derecha">
            <h3>LOMA LA LATA SEPARATION PLANT - NEUQUÉN</h3>
            <p>
              Loma La Lata is located in the heart of the Vaca Muerta formation, the main unconventional hydrocarbon reservoir in Argentina.<br><br>

              This Plant processes approximately 40 million standard cubic meters of natural gas per day
extracting approximately the equivalent to 5 million cubic meters in liquid per day. “Dry gas” or
methane is then sent to YPF S.A. and fed into the main natural gas pipeline systems (NEUBA II,
CENTER WEST AND PACIFIC). <br><br>

              Extracted liquids are then transported via a pipeline 12 inches in diameter.
            </p>
            <a target="_blank" href="https://www.youtube.com/watch?v=Oyc1XsNhQg8" >Play Video</a>
          </div>
          <div class="zurda">
              <ul class="owl-carousel">
                <li class="slide slide1">
                <a target="_blank" href="https://www.youtube.com/watch?v=Oyc1XsNhQg8"><img src="./2.jpg"  alt=""></a>
                </li>
                <li class="slide slide2">
                  <img src="./3.jpg"  alt="">
                </li>
              </ul>
          </div>
         <!--  <div class="pop">
            <video controls  src="./video1.mp4"></video>
            <span class="close">⤬</span>
          </div> -->
        </div>
        <!-- <div class="mod">
          <video controls  src="./video1.mp4"></video>
        </div> -->
        <div class="mod">
         <!--  <div class="pop1">
            <video controls  src="./video2.mp4"></video>
            <span class="close">⤬</span>
          </div> -->
          <div class="derecha derechas">
            <h3>TRATAYEN GAS PIPELINE</h3>
            <p><strong>Neuquén</strong></p>
            <p>
             The construction of the Tratayen gas pipeline will substantially enhance our production and
supply structure. This major investment will give us access to part of the gas coming from the
Fortín de Piedra field and to future Vaca Muerta resources.
            </p>
            <a target="_blank" href="https://www.youtube.com/watch?v=BJQR1BmQS48&feature=youtu.be">Play Video</a>
          </div>
          <div class="zurda zurdas">
              <ul class="owl-carousel">
                <li class="slide slide1">
                  <a target="_blank"  href="https://www.youtube.com/watch?v=BJQR1BmQS48&feature=youtu.be"><img src="./4.jpg"  alt=""></a>
                </li>
                <li class="slide slide2">
                  <img src="./5.jpg"  alt="">
                </li>
              </ul>
          </div>
        </div>
        <!-- <div class="mod">
           <video controls  src="./video2.mp4"></video>
        </div> -->
        <div class="mod">
           <!-- <div class="pop2">
            <video controls  src="./video3.mp4"></video>
            <span class="close">⤬</span>
          </div> -->
          <div class="derecha">
            <h3>BAHÍA BLANCA’S FRACTIONATION PLANT </h3>
            <p>
              This Plant is part of the largest Petrochemical Hub in the country: Buenos Aires. <br><br>

             
              These fractionation facilities separate natural gas liquids to obtain ethane, propane, butane, and
natural gasoline. In addition to this, the Plant also has dedicated storage and shipping facilities
for propane, butane, and natural gasoline.<br><br>

              One of its competitive advantages is having a pier in the access channel to the Port of
Bahía Blanca, the only deepwater port in Argentina. This allows product export in large vessels.
            </p>
            <a target="_blank" href="https://www.youtube.com/watch?v=k1anD59igqU">Play Video</a>
          </div>
          <div class="zurda">
              <ul class="owl-carousel">
                <li class="slide slide1">
                  <a target="_blank" href="https://www.youtube.com/watch?v=k1anD59igqU"><img class="tercer-btn" src="./6.jpg"  alt=""></a>
                </li>
                <li class="slide slide2">
                  <img src="./7.jpg"  alt="">
                </li>
              </ul>
          </div>
        </div>
        <!-- <div class="mod">
          <video controls  src="./video3.mp4"></video>
        </div> -->
        <div class="mod">
          <!--  <div class="pop3">
            <video controls  src="./video4.mp4"></video>
            <span class="close">⤬</span>
          </div> -->
          <div class="derecha derechas">
            <h3>600KM-LONG PIPELINE</h3>
       
            <p>
            This is the only pipeline in Argentina to connect Vaca Muerta with the international deepwater
port of Bahía Blanca. <br><br>

             A 12-inch pipeline connects both plants passing through 4 Argentine provinces: Neuquén, Río
Negro, La Pampa, and Buenos Aires.
            </p>
            <p style="margin-bottom: 25px"> <a target="_blank" href="static/pdf/Folleto-A4-Mega-v2.pdf"> Prevention and Safety<i class="icon-file-pdf"></i></a></p>
            <a target="_blank" href="https://www.youtube.com/watch?v=LrcJP42NSmI" >Play Video</a>
          </div>
          <div class="zurda zurdas">
              <ul class="owl-carousel">
                <li class="slide slide1">
                  <a target="_blank" href="https://www.youtube.com/watch?v=LrcJP42NSmI"><img class="cuarto-btn" src="./8.jpg"  alt=""></a>
                </li>
                <li class="slide slide2">
                  <img src="./9.jpg"  alt="">
                </li>
              </ul>
          </div>

        </div>
        <!-- <div class="mod">
          <video controls  src="./video4.mp4"></video>
        </div> -->
       </div>

     </section>
      <span id="comercializacion"></span>
     <section class="comercio">
        <h1 >Production and Commercial Process</h1>
      <div class="cont-1170">
        <img src="./2.png"  alt="">
        <video controls src="./video2.mp4"></video>
      </div>
    </section>
     <pieEN></pieEN>
  </article>
</template>

<script>
import $ from 'jquery'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel'
import CabeceraEN from '@/components/CabeceraEN'
import PieEN from '@/components/PieEN'
export default {
  name: 'quienesSomosEN',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted: function () {
    $('.zurda > ul').owlCarousel({
      autoplay: true,
      items: 1,
      loop: true,
      slideSpeed: 1000,
      autoplaySpeed: 500,
      singleItem: true,
      dragBeforeAnimFinish: false,
      mouseDrag: true,
      touchDrag: true,
      nav: false
    })
  },
  components: {
    CabeceraEN,
    PieEN
  }
}

$(document).ready(function () {
  $('.primer-btn').click(function () {
    $('.pop').addClass('act-pop')
  })
  $('.second-btn').click(function () {
    $('.pop1').addClass('act-pop')
  })
  $('.tercer-btn').click(function () {
    $('.pop2').addClass('act-pop')
  })
  $('.cuarto-btn').click(function () {
    $('.pop3').addClass('act-pop')
  })
  $('.close').click(function () {
    $('.pop').removeClass('act-pop')
  })
  $('.close').click(function () {
    $('.pop1').removeClass('act-pop')
  })
  $('.close').click(function () {
    $('.pop2').removeClass('act-pop')
  })
  $('.close').click(function () {
    $('.pop3').removeClass('act-pop')
  })
})

</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.comercio
  padding: 80px 0
  position: relative
  &:after
    content: ''
    height: 400px
    background: #004d9e
    width: 100%
    position: absolute
    z-index: 1
    top: 0
  h1
    text-align: center
    color: #fff
    font-size: 30px
    width: 100%
    position: relative
    z-index: 2
  .cont-1170
    max-width: 1170px
    display: flex
    flex-direction: column
    align-items: center
    padding-top: 40px
    width: 100%
    padding: 0 15px
    margin: 0 auto
    position: relative
    z-index: 2
    img
      max-width: 800px
      width: 100%
      margin: 0 auto
    video
      max-width: 1000px
      width: 100%
      margin: 0 auto
      padding-top: 50px
.cabecera
  width: 100%
  position: relative
  img
    width: 100%
    @media (max-width: 550px)
     height: 160px
  h2
    position: absolute
    top: 50%
    left: 50%
    font-size: 36px
    color: #fff
    transform: translateX(-50%)
    @media (max-width: 550px)
      top: 30%
      font-size: 25px
.cont-1300
  display: flex
  align-items: center
  max-width: 1300px
  width: 100%
  padding: 0 15px
  margin: 0 auto
  @media(max-width: 800px)
    flex-direction: column
  .left
    width: 50%
    padding: 0 50px
    @media(max-width: 800px)
      width: 100%
      padding: 30px 10px
    h2
      font-size: 30px
      color: #004d9e
      position: relative
      margin-bottom: 60px
      &:after
        width: 80px
        height: 1px 
        background: #333
        content: ''
        position: absolute
        bottom: -30px
        left: 0
    p
      font-size: 16px 
      line-height: 30px
      color: #323232
  .right
    width: 50%
    position: relative
    cursor: pointer
    @media(max-width: 800px)
      width: 100%
      margin-bottom: 20px
    video, img
      width: 100%
.instalaciones
  background: #f3f3f3
  padding: 80px 0
  position: relative
  &:after
    content: ''
    height: 400px
    background: #004d9e
    width: 100%
    position: absolute
    z-index: 1
    top: 0
  h1
    text-align: center
    color: #fff
    font-size: 30px
    width: 100%
    position: relative
    z-index: 2
  .cont-1299
    max-width: 1300px
    width: 100%
    padding: 0 15px
    margin: 0 auto
    position: relative
    z-index: 2
    .mod
      display: flex
      align-items: flex-start
      max-width: 1170px
      background: #fff
      width: 100%
      padding: 0
      position: relative
      margin: 40px auto
      @media(max-width: 800px)
        flex-direction: column
      video
        width: 100%
      .pop, .pop1, .pop2, .pop3
        width: 90%
        height: 100%
        background: #000
        opacity: 0
        position: absolute
        top: 0
        left: 50%
        transform: translateX(-50%)
        display: flex
        justify-content: center
        z-index: 0
        align-items: center
        height: auto
        transition: all .45s ease-in-out
        &.act-pop
          opacity: 1
          z-index: 999
        .close
          font-size: 25px
          color: #fff
          position: absolute
          right: 20px
          top: 20px
          cursor: pointer
        video
          width: 100%
          box-shadow: 3px 3px 15px #000
      .derecha
        width: 50%
        padding: 40px
        z-index: 99
        @media(max-width: 800px)
          width: 100%
          padding: 30px
          height: auto
        h3
          color: #004d9e
          font-size: 18px
          text-transform: uppercase
        p
          color: #323232
          font-size: 14px
          line-height: 26px
          margin-bottom: 40px
        a
          border: 1px solid #004d9e
          padding: 7px 12px
          background: #fff
          color: #004d9e
          cursor: pointer
          font-size: 15px
          text-decoration: none
          margin: 40px auto
      .zurda
        width: 50%
        @media(max-width: 800px)
          width: 100%
          height: auto
        .owl-carousel
          width: 100%
          position: relative
          .slide1
            width: 100%
            height: 560px
            display: flex
            background: #000
            @media(max-width: 800px)
              height: auto
            video 
              width: 100%
            a
              width: 100%
          .slide2
            width: 100%
            height: 560px
            @media(max-width: 800px)
              height: auto
          .owl-dots
            position: absolute !important
            bottom: 40px
            left: 50%
            transform: translateX(-50%)
            .owl-dot
              border-radius: 50%
              border: 1px solid red
              background: #fff
      .derechas
        width: 50%
        padding: 40px
        @media(max-width: 800px)
          width: 100%
          height: auto
      .zurdas
        width: 50%
        display: flex
        background: #000
        align-items: center
        @media(max-width: 800px)
          height: auto
          width: 100%
        video 
          width: 100%
        .owl-carousel
          width: 100%
          position: relative
          .slide1
            width: 100%
            height: 390px
            @media(max-width: 800px)
              height: auto
          .slide2
            width: 100%
            height: 390px
            @media(max-width: 800px)
              height: auto
              width: 100%
            .owl-dots
              position: absolute
              bottom: 40px
              left: 50%
              transform: translateX(-50%)
              .owl-dot
                border-radius: 50%
                border: 1px solid red
                background: #fff
</style>




// WEBPACK FOOTER //
// src/components/quienes-somos-en/quienesSomos-en.vue